/* Sticky add-to-cart for scrub caps. See snippets/mc-sticky-atc.liquid.

   Rules: bar shows only when (1) a size is ticked in the YMQ size box
   (.mc-fit-sizebox) and (2) the theme's own Add to cart button is off
   screen. It clicks the real button, so YMQ validation and the cart drawer
   are untouched. Every DOM write is guarded (the page already runs a body
   MutationObserver for the fit card). */
(function () {
  'use strict';
  var bar = document.querySelector('[data-mc-satc]');
  if (!bar) return;

  function sizeBox() { return document.querySelector('.mc-fit-sizebox'); }
  function realBtn() { return document.querySelector('form[action*="/cart/add"] button[type="submit"], .add-to-cart-button, button[name="add"]'); }
  function priceEl() { return document.querySelector('product-price .price'); }
  function chosenSize() {
    var b = sizeBox(); if (!b) return null;
    var i = b.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    return i ? (i.value || '').trim() : null;
  }
  /* Theme price + YMQ's add-on total ("...will add 40,94 PLN to the original
     price", .ymq-price-span[data-ymq-money] in the active currency). The
     total is written back in the theme's own format: same symbol, same
     decimal separator, same position. Falls back to the theme price alone. */
  function addonAmount() {
    var box = document.querySelector('.ymq-option-addon');
    if (!box || box.style.display === 'none' || getComputedStyle(box).display === 'none') return 0;
    var sp = box.querySelector('[data-ymq-money]');
    var v = sp ? parseFloat(sp.getAttribute('data-ymq-money')) : NaN;
    return isFinite(v) && v > 0 ? v : 0;
  }
  function totalText(priceText) {
    var extra = addonAmount();
    if (!extra) return priceText;
    var m = /(\d[\d.,\s ]*\d|\d)/.exec(priceText);
    if (!m) return priceText;
    var num = m[1], dec = '', decSep = '';
    var lastSep = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
    if (lastSep !== -1 && num.length - lastSep - 1 === 2) { decSep = num[lastSep]; dec = num.slice(lastSep + 1); }
    var intPart = (decSep ? num.slice(0, lastSep) : num).replace(/[^\d]/g, '');
    var base = parseFloat(intPart + '.' + (dec || '0'));
    if (!isFinite(base)) return priceText;
    var total = (base + extra).toFixed(decSep ? 2 : 0);
    if (decSep) total = total.replace('.', decSep);
    return priceText.slice(0, m.index) + total + priceText.slice(m.index + num.length);
  }
  function firstVisibleError() {
    var els = document.querySelectorAll('.ymq-options-box [class*="error"], .ymq-options-box[class*="error"]');
    for (var k = 0; k < els.length; k++) {
      var e = els[k];
      if (e.style.display !== 'none' && getComputedStyle(e).display !== 'none' && (e.textContent || '').trim()) return e.closest('.ymq-options-box') || e;
    }
    return null;
  }

  var btnVisible = true, shown = false, size = null;
  function setShown(on) {
    if (shown === on) return;
    shown = on;
    if (on) { bar.hidden = false; bar.setAttribute('aria-hidden', 'false'); requestAnimationFrame(function () { bar.classList.add('mc-satc--on'); }); document.documentElement.classList.add('mc-satc-open'); }
    else { bar.classList.remove('mc-satc--on'); bar.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('mc-satc-open'); setTimeout(function () { if (!shown) bar.hidden = true; }, 260); }
  }
  function sync() {
    var s = chosenSize();
    if (s !== size) {
      size = s;
      var sEl = bar.querySelector('.mc-satc__size');
      var txt = s ? ' · ' + s.replace(/\s*\(.*\)\s*$/, '') : '';
      if (sEl && sEl.textContent !== txt) sEl.textContent = txt;
    }
    var p = priceEl(), pEl = bar.querySelector('.mc-satc__price');
    if (p && pEl) { var want = totalText(p.textContent.trim()); if (pEl.textContent !== want) pEl.textContent = want; }
    var rb = realBtn(), bb = bar.querySelector('.mc-satc__btn');
    if (rb && bb) {
      var label = (rb.textContent || '').trim();
      if (label && bb.textContent !== label) bb.textContent = label;
      if (bb.disabled !== rb.disabled) bb.disabled = rb.disabled;
    }
    setShown(!!size && !btnVisible && !!rb);
  }

  var queued = false;
  function queue() { if (queued) return; queued = true; setTimeout(function () { queued = false; try { sync(); } catch (e) { /* leave the bar as it is */ } }, 60); }

  function watchBtn() {
    var rb = realBtn(); if (!rb || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) { btnVisible = es[0].isIntersecting; queue(); }, { threshold: 0 }).observe(rb);
  }

  bar.querySelector('.mc-satc__btn').addEventListener('click', function () {
    var rb = realBtn(); if (!rb) return;
    rb.click();
    setTimeout(function () {
      var err = firstVisibleError();
      if (err) { var y = err.getBoundingClientRect().top + window.pageYOffset - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
    }, 350);
  });


  /* INP fix (7 Sept 2026). YMQ lazy-loads ~930 swatch images over the first
     minute and flips a class on each one as it lands; with five scripts
     watching document.body that was 24s of blocked main thread in the first
     33s of every product page (GSC: product group INP 490ms from 4 Sept).
     Only container-level changes matter to this script; value-level class
     flips, images, the header search box and our own widgets are ignored. */
  var MC_IGNORE_ATTR = '.ymq-option-value,.ymq-option-value-item,.ymq-option-swatches-item,.ymq-option-label,.ymq-option-button-input,img,input,textarea,.search-mega-menu__input';
  var MC_OWN = '[data-mc-fit-card],.mc-fit__check,.mc-emb-cue,.mc-emb-modal,[data-mc-satc],.mc-tellus-box,.mc-terms-box';
  function mcRelevant(records) {
    for (var i = 0; i < records.length; i++) {
      var m = records[i], t = m.target;
      if (t.nodeType !== 1) { t = t.parentElement; if (!t) continue; }
      if (t.closest && t.closest(MC_OWN)) continue;
      if (m.type === 'attributes' && t.matches && t.matches(MC_IGNORE_ATTR)) continue;
      return true;
    }
    return false;
  }

  function start() {
    if (!sizeBox()) { /* not a scrub cap, or YMQ not rendered yet: wait for it once */
      var mo = new MutationObserver(function () { if (sizeBox()) { mo.disconnect(); boot(); } });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
      return;
    }
    boot();
  }
  function boot() {
    watchBtn();
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    new MutationObserver(function (records) { if (mcRelevant(records)) queue(); }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'data-ymq-money'] });
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
